@reference "@glow/tailwind-config/reference.css";

.divider {
  @apply border;
  @apply border-solid;
  border-color: rgba(0, 0, 0, 0.2);
  @apply my-0;
  @apply mx-[1.5em];
}
.divider + li:not([role="option"]) {
  @apply mt-4;
}
